import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import {getBottomSpace} from 'react-native-iphone-screen-helper';
import {Platform} from 'react-native';
export const Container = styled.View`
  background-color: ${({theme}) => theme.colors.background};
  flex: 1;
`;

export const Content = styled.View`
  padding: 0 24px;
`;

export const Form = styled.View``;

export const InputGroup = styled.View`
  margin-bottom: ${RFValue(12)}px;
`;

export const Footer = styled.View`
  padding: 0 24px;
  padding-bottom: ${Platform.OS === 'ios' && getBottomSpace()
    ? 0
    : RFValue(20)}px;
`;
